import React from 'react'
import PropTypes from 'prop-types'

import { get } from 'lodash'
import { format } from 'date-fns'
import StatusIndicator from './StatusIndicator'
import { Typography } from '@material-ui/core'

const ScheduledDate = ({ record }) => {
  const date = new Date(get(record, 'ScheduledDate', record.CreatedDate))
  const status = record.IsDraft ? 'Draft' : get(record, 'Status', 'Delivered')
  return (
    <div className="scheduled-date-comp">
      <Typography gutterBottom>{format(date, 'PP p')}</Typography>
      <StatusIndicator status={status} />
    </div>
  )
}

ScheduledDate.propTypes = {
  record: PropTypes.object.isRequired,
}

export default ScheduledDate
